import { OptOutListener } from "./OptOutListener"
import Logger from "../logger"

export class OptOutManager {
  private listeners: OptOutListener[] = []
  private _isOptOutTracking: boolean

  constructor(optOutTracking: boolean) {
    this._isOptOutTracking = optOutTracking
  }

  get isOptOutTracking(): boolean {
    return this._isOptOutTracking
  }

  addListener(listener: OptOutListener): void {
    this.listeners.push(listener)
  }

  setOptOutTracking(optOut: boolean): void {
    if (this._isOptOutTracking === optOut) return
    this._isOptOutTracking = optOut
    this.listeners.forEach((listener) => {
      try {
        listener.onOptOutChanged(optOut)
      } catch (e) {
        Logger.log.error(`Unexpected exception while notifying OptOutListener: ${e}`)
      }
    })
  }
}
